<template>
  <v-card>
    <ValidationObserver v-slot="{ invalid }">
      <v-form>
        <v-card-text>
          <v-row class="mt-4">
            <v-col>
              <ValidationProvider
                v-slot="{ errors }"
                name="Nombre"
                rules="required|max:200"
              >
                <v-text-field
                  v-model="model.name"
                  label="Nombre"
                  :counter="200"
                  :error-messages="errors"
                  required
                  dense
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                v-slot="{ errors }"
                name="Unidad de medida"
                rules="max:50"
              >
                <v-text-field
                  v-model="model.unitMeasurement"
                  label="Unidad de medida"
                  :error-messages="errors"
                  :counter="50"
                  required
                  dense
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row align="center" justify="center" class="text-center my-5 mt-4">
            <v-col>
              <ValidationProvider
                v-slot="{ errors }"
                name="Categoría"
                rules="required"
              >
                <v-autocomplete
                  v-model="model.category.idCategory"
                  label="Categoría"
                  :error-messages="errors"
                  :items="categories"
                  :item-text="categories.text"
                  :item-value="categories.value"
                  required
                  dense
                ></v-autocomplete>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                v-slot="{ errors }"
                name="Tipo de resultados"
                rules="required|max:300"
              >
                <v-autocomplete
                  v-model="model.type"
                  label="Tipo de resultados"
                  :error-messages="errors"
                  :items="types"
                  :item-text="types.text"
                  :item-value="types.value"
                  required
                  dense
                ></v-autocomplete>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-divider></v-divider>

          <v-row dense>
            <v-col cols="12" md="4">
              <v-row
                align="center"
                justify="center"
                class="text-left ml-5 mt-8 mr-5"
              >
                <v-row dense class="text-left">
                  <v-col cols="12" sm="12" md="12">
                    <v-banner
                      color="blue-grey lighten-5"
                      class="mb-4"
                      shaped
                      single-line
                    >
                      Valores de referencia
                    </v-banner>
                  </v-col>
                  <v-col class="d-flex mt-2" cols="12">
                    <v-text-field
                      v-model="referenceValue"
                      label="Valor de referencia"
                      :clear-icon="$cnst.CLEAR_ICON"
                      dense
                      clearable
                      :counter="50"
                      @keyup.enter="addReferenceValue(referenceValue)"
                    />
                    <v-btn
                      fab
                      x-small
                      color="secondary"
                      :disabled="!referenceValue"
                      @click="addReferenceValue(referenceValue)"
                      dense
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-card max-width="500">
                      <v-list dense>
                        <v-list-item
                          v-for="(item, index) in referenceValueList"
                          :key="item.value"
                        >
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item.value }}
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action
                            @click="removeReferenceValue(index)"
                          >
                            <v-icon class="hand" color="error" small
                              >mdi-delete</v-icon
                            >
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-row>
            </v-col>

            <v-col cols="12" md="4">
              <v-row
                align="center"
                justify="center"
                class="text-left ml-5 mt-8 mr-5"
              >
                <v-row dense class="text-left">
                  <v-col cols="12" sm="12" md="12">
                    <v-banner
                      color="blue-grey lighten-5"
                      class="mb-4"
                      shaped
                      single-line
                    >
                      Alias de parámetro
                    </v-banner>
                  </v-col>

                  <v-col class="d-flex mt-2" cols="12">
                    <v-text-field
                      v-model="aliasValue"
                      label="Alias"
                      :clear-icon="$cnst.CLEAR_ICON"
                      dense
                      clearable
                      :counter="50"
                      @keyup.enter="addAliasValue(aliasValue)"
                    />
                    <v-btn
                      fab
                      x-small
                      color="secondary"
                      :disabled="!aliasValue"
                      @click="addAliasValue(aliasValue)"
                      dense
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>

                  </v-col>

                  <v-col>
                    <v-card max-width="500">
                      <v-list dense>
                        <v-list-item
                          v-for="(item, index) in aliasList"
                          :key="item.name"
                        >
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item.name }}
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action @click="removeAliasValue(index)">
                            <v-icon class="hand" color="error" small
                              >mdi-delete</v-icon
                            >
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-row>
            </v-col>

            <v-col cols="12" md="4">
              <v-row
                align="center"
                justify="center"
                class="text-left ml-5 mt-8 mr-5"
              >
                <v-row dense class="text-left">
                  <v-col cols="12" sm="12" md="12">
                    <v-banner
                      color="blue-grey lighten-5"
                      class="mb-4"
                      shaped
                      single-line
                    >
                      Resultados de referencia
                    </v-banner>
                  </v-col>
                  <v-col class="d-flex mt-2" cols="12" v-if="!toggleResults">
                    <span style="font-style: italic"
                      >No aplica para tipo de resultado; abierto</span
                    >
                  </v-col>
                  <v-col class="d-flex mt-2" cols="12" v-if="toggleResults">
                    <v-text-field
                      v-model="resultValue"
                      label="Resultado de referencia"
                      :clear-icon="$cnst.CLEAR_ICON"
                      dense
                      clearable
                      :counter="50"
                      @keyup.enter="addResultValue(resultValue) "
                    />
                    <v-btn
                      fab
                      x-small
                      color="secondary"
                      :disabled="!resultValue"
                      @click="addResultValue(resultValue)"
                      dense
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>

                  </v-col>
                  <v-col v-if="toggleResults">
                    <small
                      v-if="$utilFront.isEmptyList(resultsValueList)"
                      class="error--text"
                      >Resultados de referencia no pueden quedar vacios.
                    </small>
                    <v-card max-width="500">
                      <v-list dense>
                        <v-list-item
                          v-for="(item, index) in resultsValueList"
                          :key="item.value"
                        >
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item.value }}
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action @click="removeResultValue(index)">
                            <v-icon class="hand" color="error" small
                              >mdi-delete</v-icon
                            >
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="text-center d-flex justify-center mt-8">
          <v-col cols="1">
            <v-btn outlined color="error" @click="reset()">Volver</v-btn>
          </v-col>
          <v-col cols="1">
            <v-btn
              color="primary"
              :disabled="
                invalid ||
                (toggleResults && $utilFront.isEmptyList(resultsValueList))
              "
              @click="sendParameter()"
            >
              Guardar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-form>
    </ValidationObserver>
  </v-card>
</template>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { CategoryRequest, ParameterRequest } from "@/core/request";
import mixins from "../../mixins";
export default {
  name: "ParameterForm",
  mixins: [mixins],
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    changeAction: {
      type: Function,
    },
    resetAction: {
      type: Function,
    },
  },
  data: () => ({
    types: [
      { text: "Abierto", value: 0 },
      { text: "Cerrado", value: 1 },
    ],
    categories: [],
    toggleForm: false,
    toggleResults: false,
    toggleAlias: false,

    referenceValueList: [],
    resultsValueList: [],
    aliasList: [],

    aliasValue: "",
    referenceValue: "",
    resultValue: "",

    indexReferenceValue: null,
    indexResultValue: null,
    indexAliasValue: null,
  }),
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  mounted() {
    this.fetchAllCategories();
    this.toggleResults = this.model.type == 1;
  },
  beforeMount() {
    const { referenceValues, referenceResults, parameterAliaslist } =
      this.model;

    if (referenceValues && Object.keys(referenceValues).length > 0) {
      this.toggleForm = true;
      this.referenceValueList = referenceValues;
    }

    if (parameterAliaslist && Object.keys(parameterAliaslist).length > 0) {
      this.toggleAlias = true;
      this.aliasList = parameterAliaslist;
    }

    if (referenceResults && Object.keys(referenceResults).length > 0) {
      this.toggleResults = true;
      this.resultsValueList = referenceResults;
    }
  },
  watch: {
    "model.type": function (value) {
      this.toggleResults = value === 1;
    },
  },
  methods: {
    async fetchAllCategories() {
      try {
        const response = await CategoryRequest.listAllCategory();

        this.categories = response.data.data.map((cat) => {
          return {
            text: cat.name + " - " + cat.studyModality.name,
            value: cat.idCategory,
          };
        });
      } catch (error) {
        console.log(error);
        this.$utilFront.errorhttp(error);
      }
    },

    deleteReferenceValue(idReferenceValue, index) {
      this.$swal({
        toast: true,
        title: "¿Eliminar el valor de referencia?",
        text: "Esta es un acción irreversible y tendra que agregarlo nuevamente",
        icon: "warning",
        confirmButtonText: "Aceptar",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.sending = true;
          const reqParams = {
            idReferenceValue,
          };
          ParameterRequest.deleteReferenceValue(reqParams)
            .then((response) => {
              const { code, status } = response.data;
              if (code === 200 && status === "OK") {
                this.$utilFront.notifications(
                  "Se ha eliminado correctamente.",
                  "SUCCESS"
                );
                this.referenceValueList.splice(index, 1);
              } else {
                this.$utilFront.notifications(
                  "Ocurrió un error al eliminar el valor de referencia",
                  "ERROR"
                );
              }
            })
            .catch((error) => this.$utilFront.errorhttp(error))
            .finally(() => {
              this.sending = false;
            });
        } else {
          this.swalDialog = false;
        }
      });
    },
    deleteReferenceResult(idReferenceResult, index) {
      this.$swal({
        toast: true,
        title: "¿Eliminar el resultado de referencia?",
        text: "Esta es un acción irreversible y tendra que agregarlo nuevamente",
        icon: "warning",
        confirmButtonText: "Aceptar",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.sending = true;
          const reqParams = {
            idReferenceResult,
          };
          ParameterRequest.deleteReferenceResult(reqParams)
            .then((response) => {
              const { code, status } = response.data;
              if (code === 200 && status === "OK") {
                this.$utilFront.notifications(
                  "Se ha eliminado correctamente.",
                  "SUCCESS"
                );
                this.resultsValueList.splice(index, 1);
              } else {
                this.$utilFront.notifications(
                  "Ocurrió un error al eliminar el resultado de referencia",
                  "ERROR"
                );
              }
            })
            .catch((error) => this.$utilFront.errorhttp(error))
            .finally(() => {
              this.sending = false;
            });
        } else {
          this.swalDialog = false;
        }
      });
    },
    deleteAlias(idParameterAlias, index) {
      this.$swal({
        toast: true,
        title: "¿Eliminar el alias?",
        text: "Esta es un acción irreversible y tendra que agregarlo nuevamente",
        icon: "warning",
        confirmButtonText: "Aceptar",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.sending = true;
          const reqParams = {
            idParameterAlias,
          };
          ParameterRequest.deleteAliasValue(reqParams)
            .then((response) => {
              const { code, status } = response.data;
              if (code === 200 && status === "OK") {
                this.$utilFront.notifications(
                  "Se ha eliminado correctamente.",
                  "SUCCESS"
                );
                this.aliasList.splice(index, 1);
              } else {
                this.$utilFront.notifications(
                  "Ocurrió un error al eliminar el resultado de referencia",
                  "ERROR"
                );
              }
            })
            .catch((error) => this.$utilFront.errorhttp(error))
            .finally(() => {
              this.sending = false;
            });
        } else {
          this.swalDialog = false;
        }
      });
    },

    showReferenceValueForm() {
      this.toggleForm = !this.toggleForm;
    },
    showResultValueForm() {
      this.toggleResults = !this.toggleResults;
    },
    showAliasForm() {
      this.toggleAlias = !this.toggleAlias;
    },

    addReferenceValue(value) {
      if (value) {
        const refValues = {
          value,
        };
        this.referenceValueList.push(refValues);
        this.referenceValue = "";
      }
    },
    removeReferenceValue(index) {
      // if (
      //   index >= 0 &&
      //   this.referenceValueList[index] &&
      //   this.referenceValueList[index].idReferenceValue
      // ) {
      //   this.deleteReferenceValue(
      //     this.referenceValueList[index].idReferenceValue,
      //     index
      //   );
      // } else {
        this.referenceValueList.splice(index, 1);
      // }

      // this.cancelEditReferenceValue();
    },
    getReferenceValue(item, index) {
      if (item) {
        this.referenceValue = item.value;
        this.indexReferenceValue = index;
      }
    },
    updateReferenceValue(value) {
      this.referenceValueList[this.indexReferenceValue].value = value;
      this.forceUpdateCmp();
      this.cancelEditReferenceValue();
    },
    cancelEditReferenceValue() {
      this.referenceValue = "";
      this.indexReferenceValue = null;
    },

    addResultValue(value) {
      if (value) {
        const resValues = {
          value,
        };
        this.resultsValueList.push(resValues);
        this.resultValue = "";
      }
    },
    removeResultValue(index) {
      // if (
      //   index >= 0 &&
      //   this.resultsValueList[index] &&
      //   this.resultsValueList[index].idReferenceResult
      // ) {
      //   this.deleteReferenceResult(
      //     this.resultsValueList[index].idReferenceResult,
      //     index
      //   );
      // } else {
        this.resultsValueList.splice(index, 1);
      // }
      // this.cancelEditResultValue();
    },
    getResultValue(item, index) {
      if (item) {
        this.resultValue = item.value;
        this.indexResultValue = index;
      }
    },
    updateResultValue(value) {
      this.resultsValueList[this.indexResultValue].value = value;
      this.forceUpdateCmp();
      this.cancelEditResultValue();
    },
    cancelEditResultValue() {
      this.resultValue = "";
      this.indexResultValue = null;
    },

    addAliasValue(value) {
      if (value) {
        const aliasValue = {
          name: value,
        };
        this.aliasList.push(aliasValue);
        this.aliasValue = "";
      }
    },
    removeAliasValue(index) {
      // if (
      //   index >= 0 &&
      //   this.aliasList[index] &&
      //   this.aliasList[index].idParameterAlias
      // ) {
      //   this.deleteAlias(this.aliasList[index].idParameterAlias, index);
      // } else {
        this.aliasList.splice(index, 1);
      // }
      // this.cancelEditAliasValue();
    },
    getAliasValue(item, index) {
      if (item) {
        this.aliasValue = item.name;
        this.indexAliasValue = index;
      }
    },
    updateAliasValue(value) {
      this.aliasList[this.indexAliasValue].name = value;
      this.forceUpdateCmp();
      this.cancelEditAliasValue();
    },
    cancelEditAliasValue() {
      this.aliasValue = "";
      this.indexAliasValue = null;
    },

    reset() {
      this.referenceValueList = [];
      this.resultsValueList = [];
      this.aliasList = [];
      this.resetAction();
    },

    sendParameter() {
      const parameterModel = {
        ...this.model,
        referenceValues: this.referenceValueList,
        referenceResults: this.resultsValueList,
        parameterAliaslist: this.aliasList,
      };
      this.$emit("getParameter", parameterModel);
      this.referenceValueList = [];
      this.resultsValueList = [];
      this.aliasList = [];
      this.toggleForm = false;
      this.toggleResults = false;
      this.toggleAlias = false;
    },
  },
};
</script>
